/**
 * @module Components.StripeForm
 *
 */
import React from "react";
import ProCheckoutFormWrapper, {
  PropsDef,
} from "./ProCheckoutFormWrapper";

export default function StripeForm(props: PropsDef) {
  return <ProCheckoutFormWrapper {...props} />;
}
